//https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/theme/src/components/modal.ts
import { popoverAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  popoverAnatomy.keys
);

const baseStyle = definePartsStyle({
  body: {},
  header: {
    padding: 2,
    fontSize: 'xl'
  },
  content: {
    p: 4,
    w: 'xl',
    fontSize: 'md'
  },
  closeButton: {
    boxSize: 10,
    p: 2,
    color: 'gray.500',
    _hover: {
      color: 'gray.700'
    },
    svg: {
      width: '100%',
      height: '100%',
      color: 'inherit'
    }
  }
});

const variants = {
  blue: definePartsStyle({
    content: {
      w: { base: '100vw', md: '8xl' },
      color: 'white',
      bg: 'blue.500'
    },
    body: {
      p: 4
    },
    closeButton: {
      color: 'white',
      _hover: {
        color: 'whiteAlpha.800'
      }
    }
  })
};

export const popoverTheme = defineMultiStyleConfig({ baseStyle, variants });
